<template>
  <div class="details_content_all">
    <div class="details_content_repeat">
      <QS-h4-title title="订单关联信息" />
      <div class="details_content_repeat_hundred">
        <el-form label-width="102px">
          <column-box :source="baseInfo" :list="baseInfoList" label-width="140">
          </column-box>
        </el-form>
      </div>
    </div>
    <div class="details_content_repeat">
      <QS-h4-title title="订单关联记录" />
      <div class="details_content_repeat_hundred">
        <!--bodyList 表格请求的数据-->
        <table-component
          :data="tableData"
          :columns="tableColumns"
          :total="pagination.total"
          :pageNum="pagination.pageNum"
          :pageSize="pagination.pageSize"
          :hideOnSinglePage="false"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          v-loading="loading"
          :paginationAlign="newTableComponentOptions.paginationAlign"
          :headerRowStyle="newTableComponentOptions.headerBackground"
        ></table-component>
      </div>
    </div>
  </div>
</template>

<script>
import { relationList } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  name: 'OrderRelated',
  data() {
    return {
      loading: false,
      baseInfo: {
        relationContract: '',
        relationReason: '',
        relationRemark: '',
      },
      baseInfoList: [
        {
          key: 'relationContract',
          name: '是否关联订单',
        },
        {
          key: 'relationReason',
          name: '关联原因',
        },
        {
          key: 'relationRemark',
          name: '关联说明',
        },
      ],
      tableColumns: [
        {
          label: '关联记录ID',
          key: 'id',
          width: 120,
        },
        {
          label: '关联原因',
          key: 'relationReason',
          source: selectOption.rderRelatedReason,
          width: 110,
        },
        {
          label: '原订单ID',
          key: 'oldContractId',
        },
        {
          label: '原订单状态',
          key: 'oldContractState',
          width: 120,
        },
        {
          label: '原订单车牌号',
          key: 'oldContractPlateNo',
          width: 140,
        },
        {
          label: '原订单客户',
          key: 'oldContractCustomerName',
          width: 120,
        },
        {
          label: '新订单ID',
          key: 'newContractId',
        },
        {
          label: '新订单状态',
          key: 'newContractState',
          width: 120,
        },
        {
          label: '新订单车牌号',
          key: 'newContractPlateNo',
          width: 140,
        },
        {
          label: '新订单客户',
          key: 'newContractCustomerName',
          width: 120,
        },
        {
          label: '关联记录创建时间',
          key: 'gmtCreate',
          width: 160,
        },
      ],
      // 关联数据
      tableData: [],
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      orderId: '',
    }
  },
  inject: ['orderData'],
  watch: {
    orderData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.orderId) {
          this.orderId = newVal.orderId
          this.relationList()
        }
      },
    },
  },
  methods: {
    // 获取订单关联信息
    async relationList() {
      this.loading = true
      try {
        const { code, data } = await relationList({
          contractId: this.orderId,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
        })
        if (code === 1) {
          this.tableData = data.contractList.items.map((item) => {
            return {
              ...item,
              oldContractState: selectOption.leaseOrderState[item.oldContractState],
              newContractState: selectOption.leaseOrderState[item.newContractState],
              relationExplain: selectOption.rderRelatedReason[item.relationExplain],
            }
          })
          this.pagination.total = data.contractList.totalNum
          // 是否关联订单
          this.baseInfo.relationContract = data.relationContract
          // 关联原因
          this.baseInfo.relationReason =
            selectOption.rderRelatedReason[data.relationReason]
          // 关联说明
          this.baseInfo.relationRemark = data.relationRemark
          console.log(this.baseInfo, '----')
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    sizeChange(pageSize) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = pageSize
      this.relationList()
    },
    currentChange(pageNum) {
      this.pagination.pageNum = pageNum
      this.relationList()
    },
  },
}
</script>

<style></style>
